$(document).ready(function(){
  
  $('.rte video').prop('muted','muted');
 
  $('.artist-main').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2
      }
    }
  ]
  });
});

$(document).ready(function(){
  $('.top_banner_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false,
    autoplay: true,
    autoplaySpeed: 2000
  });
});

  $(document).ready(function(){
    $('.top_banner_slide').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:false,
      autoplay: true,
      autoplaySpeed: 2000
    });
  });

$("#read_more-1").click(function(){
    $(".all_text-1").toggle();
    $(".fadded_text_main-1").toggle();
  });
  $("#read_less-1").click(function(){
    $(".all_text-1").toggle();
    $(".fadded_text_main-1").toggle();
  });

  $("#read_more-2").click(function(){
    $(".all_text-2").toggle();
    $(".fadded_text_main-2").toggle();
  });
  $("#read_less-2").click(function(){
    $(".all_text-2").toggle();
    $(".fadded_text_main-2").toggle();
  });

  $("#read_more-3").click(function(){
    $(".all_text-3").toggle();
    $(".fadded_text_main-3").toggle();
  });
  $("#read_less-3").click(function(){
    $(".all_text-3").toggle();
    $(".fadded_text_main-3").toggle();
  });

  $("#read_more-4").click(function(){
    $(".all_text-4").toggle();
    $(".fadded_text_main-4").toggle();
  });
  $("#read_less-4").click(function(){
    $(".all_text-4").toggle();
    $(".fadded_text_main-4").toggle();
  });

  $("#read_more-5").click(function(){
    $(".all_text-5").toggle();
    $(".fadded_text_main-5").toggle();
  });
  $("#read_less-5").click(function(){
    $(".all_text-5").toggle();
    $(".fadded_text_main-5").toggle();
  });

  $("#read_more-6").click(function(){
    $(".all_text-6").toggle();
    $(".fadded_text_main-6").toggle();
  });
  $("#read_less-6").click(function(){
    $(".all_text-6").toggle();
    $(".fadded_text_main-6").toggle();
  });

  $("#read_more-7").click(function(){
    $(".all_text-7").toggle();
    $(".fadded_text_main-7").toggle();
  });
  $("#read_less-7").click(function(){
    $(".all_text-7").toggle();
    $(".fadded_text_main-7").toggle();
  });

  $("#read_more-8").click(function(){
    $(".all_text-8").toggle();
    $(".fadded_text_main-8").toggle();
  });
  $("#read_less-8").click(function(){
    $(".all_text-8").toggle();
    $(".fadded_text_main-8").toggle();
  });

  $("#read_more-9").click(function(){
    $(".all_text-9").toggle();
    $(".fadded_text_main-9").toggle();
  });
  $("#read_less-9").click(function(){
    $(".all_text-9").toggle();
    $(".fadded_text_main-9").toggle();
  });

  $("#read_more-10").click(function(){
    $(".all_text-10").toggle();
    $(".fadded_text_main-10").toggle();
  });
  $("#read_less-10").click(function(){
    $(".all_text-10").toggle();
    $(".fadded_text_main-10").toggle();
  });

  $("#read_more-11").click(function(){
    $(".all_text-11").toggle();
    $(".fadded_text_main-11").toggle();
  });
  $("#read_less-11").click(function(){
    $(".all_text-11").toggle();
    $(".fadded_text_main-11").toggle();
  });

  $("#read_more-12").click(function(){
    $(".all_text-12").toggle();
    $(".fadded_text_main-12").toggle();
  });
  $("#read_less-12").click(function(){
    $(".all_text-12").toggle();
    $(".fadded_text_main-12").toggle();
  });

  $("#read_more-13").click(function(){
    $(".all_text-13").toggle();
    $(".fadded_text_main-13").toggle();
  });
  $("#read_less-13").click(function(){
    $(".all_text-13").toggle();
    $(".fadded_text_main-13").toggle();
  });

  $("#read_more-14").click(function(){
    $(".all_text-14").toggle();
    $(".fadded_text_main-14").toggle();
  });
  $("#read_less-14").click(function(){
    $(".all_text-14").toggle();
    $(".fadded_text_main-14").toggle();
  });

  $("#read_more-15").click(function(){
    $(".all_text-15").toggle();
    $(".fadded_text_main-15").toggle();
  });
  $("#read_less-15").click(function(){
    $(".all_text-15").toggle();
    $(".fadded_text_main-15").toggle();
  });

  $("#read_more-16").click(function(){
    $(".all_text-16").toggle();
    $(".fadded_text_main-16").toggle();
  });
  $("#read_less-16").click(function(){
    $(".all_text-16").toggle();
    $(".fadded_text_main-16").toggle();
  });

  $("#read_more-17").click(function(){
    $(".all_text-17").toggle();
    $(".fadded_text_main-17").toggle();
  });
  $("#read_less-17").click(function(){
    $(".all_text-17").toggle();
    $(".fadded_text_main-17").toggle();
  });

  $("#read_more-18").click(function(){
    $(".all_text-18").toggle();
    $(".fadded_text_main-18").toggle();
  });
  $("#read_less-18").click(function(){
    $(".all_text-18").toggle();
    $(".fadded_text_main-18").toggle();
  });

  $("#read_more-19").click(function(){
    $(".all_text-19").toggle();
    $(".fadded_text_main-19").toggle();
  });
  $("#read_less-19").click(function(){
    $(".all_text-19").toggle();
    $(".fadded_text_main-19").toggle();
  });

  $("#read_more-20").click(function(){
    $(".all_text-20").toggle();
    $(".fadded_text_main-20").toggle();
  });
  $("#read_less-20").click(function(){
    $(".all_text-20").toggle();
    $(".fadded_text_main-20").toggle();
  });

  $("#read_more-21").click(function(){
    $(".all_text-21").toggle();
    $(".fadded_text_main-21").toggle();
  });
  $("#read_less-21").click(function(){
    $(".all_text-21").toggle();
    $(".fadded_text_main-21").toggle();
  });



  $("#read_more-22").click(function(){
    $(".all_text-22").toggle();
    $(".fadded_text_main-22").toggle();
  });
  $("#read_less-22").click(function(){
    $(".all_text-22").toggle();
    $(".fadded_text_main-22").toggle();
  });

  $("#read_more-23").click(function(){
    $(".all_text-23").toggle();
    $(".fadded_text_main-23").toggle();
  });
  $("#read_less-23").click(function(){
    $(".all_text-23").toggle();
    $(".fadded_text_main-23").toggle();
  });

  $("#read_more-24").click(function(){
    $(".all_text-24").toggle();
    $(".fadded_text_main-24").toggle();
  });
  $("#read_less-24").click(function(){
    $(".all_text-24").toggle();
    $(".fadded_text_main-24").toggle();
  });

  $("#read_more-25").click(function(){
    $(".all_text-25").toggle();
    $(".fadded_text_main-25").toggle();
  });
  $("#read_less-25").click(function(){
    $(".all_text-25").toggle();
    $(".fadded_text_main-25").toggle();
  });

